import React, { useContext, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { PATH_INTRO, PATH_ROOT, PATH_LOADING, PATH_LINKED } from '../../paths';
// import RootContext from '../../context';
import { Base64 } from '../../utils';

export const Entrance = () => {
  const { projectId, backendURL } = useParams();
  // const { setNormalEntrance } = useContext(RootContext);
  useEffect(() => {
    // alert(`projectId: ${projectId}`);
    // alert(`backendURL: ${Base64.decode(backendURL)}`);
    localStorage.setItem('projectId', projectId);
    localStorage.setItem('backendURL', Base64.decode(backendURL));
  }, [projectId, backendURL]);
  // console.warn('[Entrance].render');
  // if (!projectId) return <div>please provide project id</div>;
  // setNormalEntrance(true);
  // return <Redirect to={`${PATH_ROOT}${PATH_LOADING}`}/>;
  return <Redirect to={`${PATH_ROOT}${PATH_INTRO}`}/>;
  // return <Redirect to={`${PATH_ROOT}${PATH_LINKED}`}/>;
};
